// Composables
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      },
      {
        path: 'categories',
        name: 'categories',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Categories.vue')
      },
      {
        path: 'moreinfo',
        name: 'moreinfo',
        component: () => import(/* webpackChunkName: "about" */ '@/views/MoreInfo.vue')
      },
      {
        path: 'institucional/:texto',
        name: 'institucional',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Institutional.vue')
      },
      {
        path: 'services/:servico',
        name: 'services',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Services.vue')
      },
      {
        path: 'profile/:menu',
        name: 'profile',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Profile.vue')
      },
      {
        path: 'favoritos',
        name: 'favoritos',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Favoritos.vue'),
      },
      {
        path: 'feed/:id',
        name: 'feed',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Feed.vue'),
      },
      {
        path: 'feed/:id/:subcategories',
        name: 'feed2',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Feed.vue')
      },
      {
        path: 'offers/:id',
        name: 'offers',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Feed.vue')
      },
      {
        path: 'cluster/:id',
        name: 'cluster',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Feed.vue')
      },
      {
        path: 'campaign/:id',
        name: 'campaign',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Feed.vue')
      },
      {
        path: 'details/:barcode',
        name: 'details',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Details.vue')
      },
      {
        path: 'search/:texto',
        name: 'search',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Search.vue')
      },
    ],
  },
  {
    path: '/register',
    component: () => import('@/layouts/Simple.vue'),
    children: [
      {
        path: '',
        name: 'register',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Register.vue')
      },
    ],
  },
  {
    path: '/checkout',
    component: () => import('@/layouts/Simple.vue'),
    children: [
      {
        path: '',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Checkout.vue')
      },
    ],
  },
  {
    path: '/order',
    component: () => import('@/layouts/Simple.vue'),
    children: [
      {
        path: '',
        name: 'order',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Order.vue')
      },
    ],
  },
  {
    path: '/baixeoapp',
    component: () => import('@/layouts/NoTemplate.vue'),
    children: [
      {
        path: '',
        name: 'baixeoapp',
        component: () => import(/* webpackChunkName: "about" */ '@/views/BaixeOApp.vue')
      },
    ],
  },
  {
    path: '/erro',
    component: () => import('@/layouts/NoTemplate.vue'),
    children: [
      {
        path: '',
        name: 'erro',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Erro.vue')
      },
    ],
  },
  {
    path: '/internet',
    component: () => import('@/layouts/NoTemplate.vue'),
    children: [
      {
        path: '',
        name: 'internet',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Internet.vue')
      },
    ],
  },
  {
    path: '/:catchAll(.*)',
    component: () => import('@/layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'Home2',
        component: () => import(/* webpackChunkName: "about" */ '@/views/Home.vue')
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_PATH),
  routes,
  scrollBehavior (to, from, savedPosition) {
    var root = document.getElementsByTagName( 'html' )[0];
    root.style.overflow = "auto";
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

let previousRoute = null

router.beforeEach((to, from, next) => {
  // Salva a rota anterior antes de navegar
  previousRoute = from
  next()
})
router.getPreviousRoute = () => previousRoute

export default router
